export default __webpack_public_path__ + "static/media/modal-pass.1f40efe1.png";